import Service from "../../AuthService";

const Billing = {
    getBillings(params) {
        return Service.get("/billing", {
            params: params
        })
    },
    getBillingById(id) {
        return Service.get("/billing/" + id)
    },
    getBillingCounts() {
        return Service.get("/billing-count")
    },
    getBillingsByCustomerId(customerIds) {
        return Service.get("/billing/customer/" + customerIds)
    },
    createBilling(data) {
        return Service.post("/billing", data)
    },
    updateBilling(id, data) {
        return Service.put("/billing/" + id, data)
    },
    deleteBilling(id) {
        return Service.delete("/billing/" + id)
    },
    changeBillingStatus(id, data) {
        return Service.put(`/billing/${id}/change-status`, data)
    },
    cancelBilling(id) {
        return Service.post("/billing/cancel" ,id)
    },
    getBillingAll(){
        return Service.get("/billing_all");
    },
    selectBillingAll(data){
        return Service.post('/select_billing_all',data);
    },
    printMultiBilling(id){
        return Service.get('/merge/billing_merge_pdf?id='+id);
    }
};

export default Billing
